import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useMobileFormModal } from '@/hooks/useMobileFormModal';

// TODO: Investigate use of Modal vs Alert Dialog.
// TODO: Standardise modals to all be same style
export function ConfirmModal(props: {
  title: string;
  message: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => any;
  isDestructive?: boolean;
}) {
  useEffect(() => setIsBusy(false), [props.isOpen]);

  const [isBusy, setIsBusy] = useState(false);
  const { modalSize, isCentered, scrollBehavior, contentProps, footerPb, titleFontSize } = useMobileFormModal();

  async function confirm() {
    setIsBusy(true);
    await props.onConfirm();
    props.onClose();
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      isCentered={isCentered}
      size={modalSize}
      scrollBehavior={scrollBehavior}
    >
      <ModalOverlay />
      <ModalContent {...contentProps}>
        <ModalHeader>
          <Heading fontSize={titleFontSize}>{props.title}</Heading>
        </ModalHeader>
        <ModalCloseButton mt={2} mr={2} />
        <ModalBody px={{ base: 4, md: 6 }}>
          <Text whiteSpace='pre-wrap'>{props.message}</Text>
        </ModalBody>
        <ModalFooter pb={footerPb}>
          <Stack direction={{ base: 'column-reverse', md: 'row' }} spacing={3} w='full' justify='flex-end'>
            <Button w={{ base: 'full', md: 'auto' }} isDisabled={isBusy} onClick={props.onClose}>
              Cancel
            </Button>
            <Button
              w={{ base: 'full', md: 'auto' }}
              colorScheme={props.isDestructive ? 'red' : 'green'}
              isLoading={isBusy}
              onClick={confirm}
            >
              Confirm
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
